'use client';

import Image from 'next/image';

import { smoothScrollTo, targetToId } from './smooth-scroll';

interface FinalCtaProps {
  cityName: string;
  ctaTarget?: string;
  ctaLabel?: string;
}

export function FinalCta({
  cityName,
  ctaTarget = '#calculator',
  ctaLabel = 'Calculate Your Earnings',
}: FinalCtaProps) {
  return (
    <section className="relative w-full overflow-hidden px-4 py-20 sm:py-28">
      {/* Background silhouette image with green overlay */}
      <Image
        src="/images/landing/drivers/cta-driver-silhouette.webp"
        alt=""
        fill
        className="object-cover"
        loading="lazy"
      />
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'var(--landing-primary)', opacity: 0.8 }}
      />

      <div className="relative z-10 mx-auto max-w-6xl text-center">
        <h2
          className="text-5xl font-black sm:text-7xl"
          style={{ color: 'var(--landing-secondary)' }}
        >
          READY?
        </h2>

        <p
          className="mt-4 text-lg"
          style={{ color: 'var(--landing-secondary)', opacity: 0.7 }}
        >
          Join drivers in {cityName}
        </p>

        <div className="mt-10">
          <a
            href={ctaTarget}
            onClick={smoothScrollTo(targetToId(ctaTarget))}
            className="inline-flex h-14 items-center justify-center rounded-xl px-12 text-lg font-bold text-white transition-opacity hover:opacity-90"
            style={{ backgroundColor: 'var(--landing-secondary)' }}
            data-test="final-cta"
          >
            {ctaLabel}
          </a>
        </div>
      </div>
    </section>
  );
}
